import { render } from "./SearchResultsCompany.vue?vue&type=template&id=89584864&scoped=true"
import script from "./SearchResultsCompany.vue?vue&type=script&lang=js"
export * from "./SearchResultsCompany.vue?vue&type=script&lang=js"

import "./SearchResultsCompany.vue?vue&type=style&index=0&id=89584864&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89584864"]])

export default __exports__